// TokenAcquisition.js
import React, { useEffect, useState } from 'react';
import { useMsal } from '@azure/msal-react';
import { InteractionRequiredAuthError } from '@azure/msal-browser';
import config from 'utils/config';
import { getCookie, deleteAllCookies, setCookie, isWebView } from 'utils/commonFunctions';
import { useDispatch } from 'react-redux';
import { usePostWebLoginMutation } from 'api';
import { resetCreateTeamReduxState, setUserLoggedIn } from 'store/slice/loginSlice';
import { useNavigate } from 'react-router-dom';
const TokenAcquisition = () => {
  const [isExpireToken, setIsExpireToken] = useState({
    flag: false,
    retVal: 0
  });
  const { instance, accounts } = useMsal();
  const navigate = useNavigate();

  const [postWebLogin] = usePostWebLoginMutation();
  const dispatch = useDispatch();
  const gameCookie = getCookie(config.gameCookieName);

  window.si_icc_access_token = {
    setIsExpireToken
  };

  const logoutFunc = async () => {
    // logout request start 👇
    const logoutRequest = {
      postLogoutRedirectUri: '/top-picks/home',
      policy: 'B2C_1A_SIGNINSIGNUP' // Specify the policy if needed
    };
    // Reset Redux States
    // dispatch(resetCreateTeamReduxState());
    deleteAllCookies(false);
    await instance.logoutRedirect(logoutRequest);

    // logout request end ☝
  };

  const aquireToken = () => {
    // const activeAccount = instance.getActiveAccount();
    const activeAccount = accounts[0];

    if (!activeAccount) {
      console.error('No active account! Please log in.');
      logoutFunc();
    }

    instance
      .acquireTokenSilent({
        scopes: [
          'openid',
          'offline_access',
          config.envMsalAzureFlag
            ? 'https://iccprdlogin.onmicrosoft.com/api/catalogue.read'
            : 'https://iccdevlogin.onmicrosoft.com/api/catalogue.read'
        ],
        account: activeAccount
      })
      .then(async (response) => {
        let payload =
          isExpireToken?.retVal == -555
            ? {
                'x-refresh-token': gameCookie?.web_refresh_token
              }
            : {
                'x-access-token': isWebView()
                  ? localStorage.getItem('accessToken')
                  : response.accessToken
              };

        const webApiCallResponse = await postWebLogin({
          postData: payload
        });
        if (webApiCallResponse.data.Meta.RetVal == 1) {
          setCookie('icc-game-cookie', JSON.stringify(webApiCallResponse?.data?.Data?.Value));
          dispatch(setUserLoggedIn(true));
          // setTimeout(() => {
          //   isExpireToken?.flag && window.location.reload();
          // }, 1000);
          window.location.reload();
        } else if (webApiCallResponse.data.Meta.RetVal == -64) {
          logoutFunc();
        }
      })
      .catch((error) => {
        if (error instanceof InteractionRequiredAuthError) {
          instance
            .acquireTokenRedirect({
              scopes: [
                'openid',
                'offline_access',
                config.envMsalAzureFlag
                  ? 'https://iccprdlogin.onmicrosoft.com/api/catalogue.read'
                  : 'https://iccdevlogin.onmicrosoft.com/api/catalogue.read'
              ]
            })
            .then(async (response) => {
              console.log(response.accessToken);
              localStorage.setItem('Denied', 'Logged out');
              // const webApiCallResponse = await postWebLogin({
              //   'x-access-token': response.accessToken
              // });
              // if (webApiCallResponse.data.Meta.RetVal == 1) {
              //   app.setCookie(
              //     'icc-game-cookie',
              //     JSON.stringify(webApiCallResponse?.data?.Data?.Value)
              //   );
              setTimeout(() => {
                window.location.reload();
              }, 1000);
              // }
            })
            .catch((error) => {
              console.error(error);
            });
          // logoutFunc();
        } else {
          console.error(error);
        }
      });
  };

  useEffect(() => {
    if (accounts.length > 0) {
      // instance.setActiveAccount(accounts[0]);
      !gameCookie && aquireToken();
    }
  }, [accounts]);

  useEffect(() => {
    // instance.setActiveAccount(accounts[0]);
    isExpireToken?.flag && aquireToken();
  }, [isExpireToken]);

  useEffect(() => {
    const preLoginRoute = localStorage.getItem('preLoginRoute');
    if (preLoginRoute) {
      navigate(preLoginRoute);
      //  sessionStorage.removeItem('preLoginRoute');
    }
  }, [navigate]);
  return null;
};

export default TokenAcquisition;
